import React from 'react';

import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

import { history } from 'containers/App';

/* eslint-disable react/prop-types, react/no-unstable-nested-components */
const AdvancedSearchActions = ({ permissions, settings, onCloneClick }) => ({
  id: 'action-column',
  Header: <span className="expand-header-offset">View</span>,
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      { AccessControl.hasPermission(
        permissions,
        [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate]
      ) && <button
        type="button"
        title={ settings?.selectedClient?.key !== row.original.clientId ? `You must switch to Client '${ row.original.clientName }' to view this form.` : 'View Form' }
        className="btn btn-sm"
        onClick={ () => history.push(`/forms/${ row.original.formType.toLowerCase() }/${ row.original.itemId }`) }
        id={ `form-view-btn-${ row.original.itemId }` }
        disabled={ settings?.selectedClient?.key !== row.original.clientId }
      >
        <span className="icon icon-apps" />
      </button> }

      { AccessControl.hasPermission(
        permissions,
        [ActivityPerms.scannedView, ActivityPerms.scannedEdit]
      ) && <button
        type="button"
        title="Clone Form"
        className="btn btn-sm"
        onClick={ () => onCloneClick(row.original) }
        id={ `form-clone-btn-${ row.original.itemId }` }
      >
        <span className="icon icon-copy" />
      </button> }
    </div>
  ),
  className: 'col-10p'
});
/* eslint-enable react/prop-types, react/no-unstable-nested-components */

export default AdvancedSearchActions;
